import styled from 'styled-components';

const ContentWrapper = styled.article`
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  flex-grow: 1;
`;

// eslint-disable-next-line import/prefer-default-export
export { ContentWrapper };
